import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  status: string;
  page: string | null;
  employeeId: string;
  patientId: string;
  paymentMethod: string;
  startDate: string;
  endDate: string;
  accountId: string;
};

const donwloadReportEntriesToPDF = async ({ page,accountId,employeeId,endDate,patientId,paymentMethod,startDate,status }: Props) => {
  const pageParams = `page=${page || 1}?status=${status}&accountId=${accountId}&startDate=${startDate}&endDate=${endDate}&employeeId=${employeeId}&patientId=${patientId}&paymentMethod=${paymentMethod}`;

  const response = await httpRequest.get(
    `/financy-entry-report-in-pdf?${pageParams}`,
    {
      responseType: "blob",
    }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `report-entries.pdf`);
  document.body.appendChild(link);
  link.click();
  if (link.parentNode) {
    link.parentNode.removeChild(link);
  } else {
    document.body.removeChild(link);
  }
};

export function useDownloadReportEntriesToPDFMutation(props: Props) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => donwloadReportEntriesToPDF(props),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["report-entires-download-excel", props.page],
      });
    },
  });
}
